import {Card, Action, DataStatus, Search} from 'platform/components';
import {Show, VStack} from 'platform/foundation';

import {useState} from 'react';

import {SmartSearchVehicleApiResponse} from '@dms/api/customer';
import {FullVehicleResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {buildArray, suffixTestId, TestIdProps} from 'shared/web';

import {SuggestedVehicle} from './SuggestedVehicle';

interface SuggestedVehiclesProps extends TestIdProps {
  selectedVehicle: FullVehicleResponseBody | null;
  suggestedVehicles: SmartSearchVehicleApiResponse;
  onVehicleChange: (vehicleId: string | null) => void;
  onAddNew: () => void;
  onSearchChange?: (searchQuery: string | null) => void;
  isLoading: boolean;
  isError: boolean;
  allowNoVehicle?: boolean;
}

export function SuggestedVehicles(props: SuggestedVehiclesProps) {
  const [searchQuery, setSearchQuery] = useState<string | null>(null);

  const handleSearchChange = (value: string | null) => {
    setSearchQuery(value);
    props.onSearchChange?.(value);
  };

  return (
    <Card
      actions={buildArray<Action>().add({
        type: 'button',
        variant: 'link',
        leftIcon: 'content/add_circle',
        title: i18n.t('general.actions.addNew'),
        onClick: props.onAddNew,
      })}
      title={i18n.t('entity.vehicle.labels.vehicle')}
      data-testid={suffixTestId('header', props)}
    >
      <VStack spacing={4}>
        <Show when={props.onSearchChange}>
          <Search
            value={searchQuery}
            onChange={handleSearchChange}
            data-testid={suffixTestId('search', props)}
          />
        </Show>
        <DataStatus
          isLoading={props.isLoading}
          isError={props.isError}
          minHeight={80}
          isEmpty={!props.suggestedVehicles?.length && !!searchQuery}
        >
          <VStack spacing={4}>
            <Show when={props.allowNoVehicle}>
              <Card
                variant="inlineWhite"
                title={i18n.t('page.workshop.placeholders.noVehicle')}
                control={{
                  type: 'radio',
                  value: props.selectedVehicle === null,
                  onChange: () => props.onVehicleChange(null),
                }}
              />
            </Show>
            {props.suggestedVehicles?.map(
              (suggested) =>
                suggested && (
                  <SuggestedVehicle
                    key={suggested.id}
                    customerTypeTitle={suggested.customerTypes?.[0]?.label}
                    vehicleId={suggested.id}
                    isSelected={props.selectedVehicle?.id === suggested.id}
                    onSelect={props.onVehicleChange}
                    isExpanded={props.suggestedVehicles?.length === 1}
                    vehicleTitle={suggested.vehicleTitle}
                    vehicleRegistrationPlate={suggested.vehicleRegistrationPlate}
                    vehicleVin={suggested.vehicleVin}
                  />
                )
            )}
          </VStack>
        </DataStatus>
      </VStack>
    </Card>
  );
}
